export const BOARD_NAME_EXISTS_MESSAGE = 'Board Name Already Exists';
export const BOARD_TYPE_REQUIRED_MESSAGE = 'Select a Board Type to continue';
export const COMPANY_REQUIRED_MESSAGE = 'Select a Company to continue';
export const SUBMISSION_FAILED_MESSAGE = 'Failed to Create the Board, please refresh and try again.';
